var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("studip-dialog", {
    attrs: {
      title: _vm.$gettext("Darstellung"),
      confirmText: _vm.$gettext("Speichern"),
      confirmClass: "accept",
      closeText: _vm.$gettext("Schließen"),
      closeClass: "cancel",
      height: "540",
      width: "870",
    },
    on: {
      close: function close($event) {
        return _vm.$emit("close")
      },
      confirm: _vm.storeLayout,
    },
    scopedSlots: _vm._u([
      {
        key: "dialogContent",
        fn: function fn() {
          return [
            _vm.currentElement && !_vm.loadingInstance
              ? _c(
                  "div",
                  {
                    staticClass: "cw-unit-item-dialog-layout-content",
                  },
                  [
                    _c(
                      "form",
                      {
                        staticClass:
                          "default cw-unit-item-dialog-layout-content-image",
                        on: {
                          submit: function submit($event) {
                            $event.preventDefault()
                          },
                        },
                      },
                      [
                        _c("label", [
                          _vm._v(_vm._s(_vm.$gettext("Vorschaubild"))),
                        ]),
                        _vm._v(" "),
                        _vm.showPreviewImage
                          ? _c("img", {
                              staticClass:
                                "cw-structural-element-image-preview",
                              attrs: {
                                src: _vm.image,
                                alt: _vm.$gettext("Vorschaubild"),
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showPreviewImage
                          ? _c("label", [
                              _c(
                                "button",
                                {
                                  staticClass: "button",
                                  on: {
                                    click: _vm.deleteImage,
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$gettext("Bild löschen")))]
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.uploadFileError
                          ? _c("courseware-companion-box", {
                              attrs: {
                                msgCompanion: _vm.uploadFileError,
                                mood: "sad",
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.showPreviewImage
                          ? [
                              _vm.currentFile
                                ? _c("img", {
                                    staticClass:
                                      "cw-structural-element-image-preview",
                                    attrs: {
                                      src: _vm.uploadImageURL,
                                      alt: _vm.$gettext("Vorschaubild"),
                                    },
                                  })
                                : _c("div", {
                                    staticClass:
                                      "cw-structural-element-image-preview-placeholder",
                                  }),
                              _vm._v(" "),
                              _c("label", [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.$gettext("Bild hochladen")) +
                                    "\n                        "
                                ),
                                _c("input", {
                                  ref: "upload_image",
                                  staticClass: "cw-file-input",
                                  attrs: {
                                    type: "file",
                                    accept: "image/*",
                                  },
                                  on: {
                                    change: _vm.checkUploadFile,
                                  },
                                }),
                              ]),
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.$gettext("oder")) +
                                  "\n                    "
                              ),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "button",
                                  attrs: {
                                    type: "button",
                                  },
                                  on: {
                                    click: function click($event) {
                                      _vm.showStockImageSelector = true
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$gettext(
                                          "Aus dem Bilderpool auswählen"
                                        )
                                      ) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _vm.showStockImageSelector
                                ? _c("StockImageSelector", {
                                    on: {
                                      close: function close($event) {
                                        _vm.showStockImageSelector = false
                                      },
                                      select: _vm.onSelectStockImage,
                                    },
                                  })
                                : _vm._e(),
                            ]
                          : _vm._e(),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "form",
                      {
                        staticClass:
                          "default cw-unit-item-dialog-layout-content-settings",
                        on: {
                          submit: function submit($event) {
                            $event.preventDefault()
                          },
                        },
                      },
                      [
                        _c("label", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$gettext("Titel")) +
                              "\n                    "
                          ),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.currentElement.attributes.title,
                                expression: "currentElement.attributes.title",
                              },
                            ],
                            attrs: {
                              type: "text",
                            },
                            domProps: {
                              value: _vm.currentElement.attributes.title,
                            },
                            on: {
                              input: function input($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.currentElement.attributes,
                                  "title",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("label", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$gettext("Beschreibung")) +
                              "\n                    "
                          ),
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value:
                                  _vm.currentElement.attributes.payload
                                    .description,
                                expression:
                                  "currentElement.attributes.payload.description",
                              },
                            ],
                            staticClass: "cw-structural-element-description",
                            domProps: {
                              value:
                                _vm.currentElement.attributes.payload
                                  .description,
                            },
                            on: {
                              input: function input($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.currentElement.attributes.payload,
                                  "description",
                                  $event.target.value
                                )
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c(
                          "label",
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$gettext("Farbe")) +
                                "\n                    "
                            ),
                            _c("studip-select", {
                              staticClass: "cw-vs-select",
                              attrs: {
                                options: _vm.colors,
                                reduce: function reduce(color) {
                                  return color.class
                                },
                                label: "name",
                                clearable: false,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "open-indicator",
                                    fn: function fn(selectAttributes) {
                                      return [
                                        _c(
                                          "span",
                                          _vm._b(
                                            {},
                                            "span",
                                            selectAttributes,
                                            false
                                          ),
                                          [
                                            _c("studip-icon", {
                                              attrs: {
                                                shape: "arr_1down",
                                                size: 10,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "no-options",
                                    fn: function fn() {
                                      return [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$gettext(
                                                "Es steht keine Auswahl zur Verfügung"
                                              )
                                            ) +
                                            ". "
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                  {
                                    key: "selected-option",
                                    fn: function fn(option) {
                                      return [
                                        _c("span", {
                                          staticClass: "vs__option-color",
                                          style: {
                                            "background-color": option.hex,
                                          },
                                        }),
                                        _c("span", [
                                          _vm._v(_vm._s(option.name)),
                                        ]),
                                      ]
                                    },
                                  },
                                  {
                                    key: "option",
                                    fn: function fn(option) {
                                      return [
                                        _c("span", {
                                          staticClass: "vs__option-color",
                                          style: {
                                            "background-color": option.hex,
                                          },
                                        }),
                                        _c("span", [
                                          _vm._v(_vm._s(option.name)),
                                        ]),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                1210816665
                              ),
                              model: {
                                value:
                                  _vm.currentElement.attributes.payload.color,
                                callback: function callback($$v) {
                                  _vm.$set(
                                    _vm.currentElement.attributes.payload,
                                    "color",
                                    $$v
                                  )
                                },
                                expression:
                                  "currentElement.attributes.payload.color",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("label", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$gettext("Titelseite")) +
                              "\n                    "
                          ),
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.currentRootLayout,
                                  expression: "currentRootLayout",
                                },
                              ],
                              on: {
                                change: function change($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function (o) {
                                      return o.selected
                                    })
                                    .map(function (o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.currentRootLayout = $event.target.multiple
                                    ? $$selectedVal
                                    : $$selectedVal[0]
                                },
                              },
                            },
                            [
                              _c(
                                "option",
                                {
                                  attrs: {
                                    value: "default",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$gettext("Automatisch")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "option",
                                {
                                  attrs: {
                                    value: "toc",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$gettext(
                                        "Automatisch mit Inhaltsverzeichnis"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "option",
                                {
                                  attrs: {
                                    value: "classic",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$gettext("Frei bearbeitbar"))
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "option",
                                {
                                  attrs: {
                                    value: "none",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$gettext("Keine")))]
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }